module.exports = __webpack_public_path__ + "img/wbicon-nansha.294c0023.jpg";